import {useSetPageTitle,} from "../../hooks";


export function HostIndexPage() {    
    useSetPageTitle("Host", []);

    return (
     <div></div>
    );
}

export default HostIndexPage;